import he from 'he';
import {t} from 'ttag';
import PropTypes from "prop-types";
import React, {useState} from "react";
import {Paper, CircularProgress, Typography} from "@material-ui/core";
import {refType} from '@material-ui/utils';
import CloseIcon from '@material-ui/icons/Close'
import Autocomplete from "@material-ui/lab/Autocomplete";
import OpenWindowIcon from "../../../Icons/OpenWindowIcon";
import {TextInput} from "../../../index";
import {filterAirports, sortAirports} from "./airportsTools";
import useStyles from "./AirportSelectorStyles";

const AirportSelector = ({
     options, label, placeholder, variant, leftRadius, rightRadius,
     onChange, disabled, value, autoFocus, onFocus, onBlur, inputRef,
     noOptionsText, optionField, compressed, hideIcon, loading, flat, error, ...props
 }) => {

    const classes = useStyles();
    const [open, setOpen] = useState(false);

    const handleOnFocus = e => {
        if (onFocus) onFocus(e);
    };

    const handleBlur = e => {
        if (onBlur) onBlur(e);
    }

    const filterOptions = (options, {inputValue}) => {
        return sortAirports(options, inputValue).filter(airport => filterAirports(airport, inputValue));
        /*return options.filter(airport => {
            const regEx = new RegExp(`.*(${inputValue}.*)`, 'gi');
            if (airport.code.match(regEx)) return true;
            if (he.decode(airport.name).match(regEx)) return true;
            if (he.decode(airport.cityName).match(regEx)) return true;
            if (he.decode(airport.countryName).match(regEx)) return true;
            return (he.decode(airport.regionName).match(regEx));
        });*/
    };

    return (
        <div className={'azo-airport-selector'}>
            <Autocomplete
                aria-label={label}
                PaperComponent={params => (
                    <div className={'azo-airport-list-popup'}>
                        <Paper square elevation={1} {...params}/>
                    </div>
                )}
                popupIcon={!hideIcon ? (loading ? (<CircularProgress size={20}/>) : (open ? <CloseIcon color={'secondary'}/> : <OpenWindowIcon color={'secondary'}/>)) : null}
                options={sortAirports(options)}
                getOptionLabel={option => he.decode(option[optionField])}
                renderInput={params => (
                    <TextInput
                        {...params}
                        variant={variant}
                        inputRef={inputRef}
                        autoFocus={autoFocus}
                        placeholder={placeholder}
                        label={!flat ? label : ''}
                        shrink={!compressed}
                        flat={flat}
                        ariaLabel={label}
                        error={error}
                        infiniteOptions={{
                            infiniteLeft: Boolean(rightRadius),
                            infiniteRight: Boolean(leftRadius),
                            // infiniteBottom: Boolean(open)
                        }}
                    />
                )}
                // renderOption={RenderOption}
                renderOption={(opt, value) => (
                    <div className={['airport-selector-list-item', classes.listItem].join(' ')} style={{width: '100%'}}>
                        <Typography color={'primary'}>
                            <span dangerouslySetInnerHTML={{
                                __html: he.decode(opt.name).replace(new RegExp(`(${value.inputValue})`, 'gi'), "<b>$1</b>")
                            }}/>
                        </Typography>
                        <Typography variant='subtitle1' className={classes.listItemCode} component='h6'>
                            {opt.code}
                        </Typography>
                    </div>
                )}
                disableClearable
                selectOnFocus
                autoHighlight
                onFocus={handleOnFocus}
                onBlur={handleBlur}
                onChange={(e, v) => onChange(v)}
                disabled={disabled}
                value={value || null}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                noOptionsText={noOptionsText ? noOptionsText : t`No airports found...`}
                openOnFocus
                filterOptions={filterOptions}
                classes={variant === 'azo' ? {
                    paper: classes.paper,
                    inputRoot: classes.inputRoot,
                    input: [classes.input, flat ? classes.inputFlatted : ''].join(' '),
                    popupIndicator: classes.popupIndicator,
                    option: classes.option,
                } : {}}
                loading={loading}
                {...props}
            />
        </div>
    );
};

AirportSelector.airportShape = PropTypes.shape({
    code: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    cityName: PropTypes.string,
    countryCode: PropTypes.string,
    countryName: PropTypes.string,
    regionName: PropTypes.string,
    azores: PropTypes.bool,
    destinations: PropTypes.arrayOf(PropTypes.string),
    airlineOperated: PropTypes.bool,
});

AirportSelector.propTypes = {
    options: PropTypes.arrayOf(AirportSelector.airportShape).isRequired,
    variant: PropTypes.oneOf(['standard', 'outlined', 'filled', 'azo']),
    label: PropTypes.string,
    placeholder: PropTypes.string,
    leftRadius: PropTypes.bool,
    rightRadius: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    value: AirportSelector.airportShape,
    autoFocus: PropTypes.bool,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    inputRef: refType,
    noOptionsText: PropTypes.string,
    optionField: PropTypes.string,
    compressed: PropTypes.bool,
    hideIcon: PropTypes.bool,
    flat: PropTypes.bool,
    error: PropTypes.bool,
};

AirportSelector.defaultProps = {
    variant: 'azo',
    leftRadius: false,
    rightRadius: false,
    disabled: false,
    autoFocus: false,
    optionField: 'name',
    compressed: false,
    hideIcon: false,
    flat: false,
    error: false,
};

export default AirportSelector;
